/* eslint-disable react-hooks/exhaustive-deps */
import { HTMLAttributes, useEffect } from "react";
import "./style.css";

const MainWrapper = ({ children, className = "", ...props }: HTMLAttributes<HTMLDivElement>) => {
    useEffect(() => {
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
    }, [window.location.href]);

    return (
        <div className={`main-content-wrapper ${className}`} {...props}>
            {children}
        </div>
    );
};

export default MainWrapper;
